var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',[_vm._v(" "+_vm._s(_vm.t == 1 ? "【单选】" : _vm.t == 2 ? "【多选】" : "【不定项】")+" "),(_vm.$attrs.topicScore)?_c('span',[_vm._v("（分值："+_vm._s(_vm.score)+"分）")]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }